<template>
  <v-card class="payment-card rounded-lg" elevation="10">
    <v-card-title class="headline d-flex justify-space-between align-center pa-6 primary white--text">
      <span class="text-h5">Agregar pago</span>
      <v-btn icon @click="close" color="white">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-6 mt-n2">
      <v-row justify="center" align="center" class="mb-4">
        <span class="text-h6 grey--text text--darken-1">TOTAL</span>
        
        <span class="text-h4 font-weight-bold primary--text ml-4"> {{ currencyFormat(amount) }}</span>
      </v-row>

      <v-divider class="mb-3"></v-divider>

      <h3 class="text-h6 mb-2">Método de pago</h3>

      <v-item-group v-if="typePayment == null" mandatory>
        <v-row>
          <v-col v-for="item in newPayments" :key="item.id" cols="6" sm="4">
            <v-hover v-slot="{ hover }">
              <v-card
                outlined
                :elevation="hover ? 8 : 2"
                class="payment-method-card transition-swing"
                @click="selectType(item)"
              >
                <v-card-text class="text-center pa-6">
                  <v-icon size="48" color="primary">{{ getIcon(item.id) }}</v-icon>
                  <div class="mt-4 text-subtitle-1">{{ item.name }}</div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-item-group>

      <v-card-text v-if="typePayment != null" class="mt-4">
        <v-card flat>
          <v-row class="mb-4" justify="end">
            <v-btn color="primary" text @click="typePayment = null">
              <v-icon left>mdi-arrow-left</v-icon>
              Cambiar método
            </v-btn>
          </v-row>

          <v-card outlined class="pa-6">
            <v-row justify="space-between" align="center" class="mb-6">
              <span class="text-subtitle-1">POR PAGAR</span>
              <span class="text-h6 font-weight-medium"> {{ currencyFormat(amount) }}</span>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedCash"
                  :label="getLabelSelected()"
                  outlined
                  dense
                  @keyup.enter="sendPayments"
                  ref="amountCash"
                  autofocus
            
                ></v-text-field>
              </v-col>
            </v-row>

            <template v-if="typePayment == 1">
              <v-divider class="my-4"></v-divider>
              <h4 class="text-subtitle-1 mb-4">OPCIONES RÁPIDAS</h4>
              <v-row justify="center">
                <v-btn @click="selectedCash = amount" class="ma-2" outlined>
                 {{ currencyFormat(amount) }}
                </v-btn>
                <v-btn @click="selectedCash = (parseFloat(amount) + parseFloat(amount) * 0.1).toFixed(2)" class="ma-2" outlined>
                 {{ currencyFormat((parseFloat(amount) + parseFloat(amount) * 0.1).toFixed(2)) }}
                </v-btn>
                <v-btn @click="selectedCash = (parseFloat(amount) + parseFloat(amount) * 0.2).toFixed(2)" class="ma-2" outlined>
               {{ currencyFormat((parseFloat(amount) + parseFloat(amount) * 0.2).toFixed(2)) }}
                </v-btn>
              </v-row>
            </template>

            <template v-if="typePayment == 2">
              <v-divider class="my-4"></v-divider>
              <h4 class="text-subtitle-1 mb-4">Tipo de tarjeta</h4>
              <v-row justify="center">
                <v-btn-toggle mandatory color="primary" class="rounded-lg">
                  <v-btn>Débito</v-btn>
                  <v-btn>Crédito</v-btn>
                </v-btn-toggle>
              </v-row>
            </template>

            <template v-if="typePayment == newPayments.length">
              <v-data-table
                :headers="headers"
                :items="payments"
                hide-default-footer
                hide-default-header
                dense
                class="elevation-1 mt-4"
              >
                <template v-slot:item.amount="{ item }">
                  <v-text-field
                    v-model="item.amount"
                    type="number"
                    min="0"
                    outlined
                    dense
                    hide-details
                    class="mt-2"
                  ></v-text-field>
                </template>
              </v-data-table>
              <v-card outlined class="mt-4 pa-4">
                <v-row justify="space-between" align="center">
                  <span class="text-h6">Total</span>
                  <span class="text-h6 font-weight-bold">{{ total }}</span>
                </v-row>
              </v-card>
            </template>
          </v-card>
        </v-card>
      </v-card-text>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="pa-6">
      <v-spacer></v-spacer>
      <v-btn text @click="close" class="text-capitalize">Cancelar</v-btn>
      <v-btn
        v-if="typePayment != null"
        color="primary"
        @click="sendPayments"
        class="text-capitalize"
        rounded
      >
        <v-icon left>mdi-plus</v-icon>
        Agregar pago
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  // The script section remains unchanged
  data: () => ({
    selectedCash: null,
    payments: [],
    newPayments: [],
    search: "",
    typePayment: null,
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Descripcion", value: "name" },
      { text: "Monto", value: "amount", width: "15%" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    editedIndex: -1,
    editedItem: [],
  }),
  props: {
    amount: {
      type: Number,
    },
  },
  computed: {
    total() {
      let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });

      let total = 0;

      for (let item of this.payments) {
        if (item.amount > 0) {
          total += parseFloat(item.amount);
        }
      }

      return formatter.format(total.toFixed(2));
    },

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo contacto" : "Editar contacto";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async getData() {
      let resultTypePayments = await this.api_Get("income/payments_types");
      let payment = [];
      for (let item of await resultTypePayments.json()) {
        this.payments.push({ id: item.id, name: item.name, amount: 0 });
        payment.push({ id: item.id, name: item.name, amount: 0 });
      }
      let newPayment = [];
      newPayment = payment;
      newPayment.push({
        id: this.payments.length + 1,
        name: "Combinado",
        amount: 0,
      });
      this.newPayments = newPayment;
    },
    selectType(item) {
      this.typePayment = item.id;
    },
    getLabelSelected() {
      if (this.typePayment == 1) {
        return "Efectivo";
      }
      if (this.typePayment == 2) {
        return "Tarjeta";
      }
      if (this.typePayment == 3) {
        return "Cheque";
      }
      if (this.typePayment == 4) {
        return "Transferencia/Deposito";
      }
    },
    getIcon(icon) {
      if (icon == 1) {
        return "payments";
      }
      if (icon == 2) {
        return "credit_card";
      }
      if (icon == 3) {
        return "mail";
      }
      if (icon == 4) {
        return "account_balance";
      }
      if (icon == 5) {
        return "mdi-account-credit-card-outline";
      }
    },
    async initialize() {
      this.getData();
    },
    sendPayments() {
      let data = [];
      if (this.typePayment != null) {
      }
      if (this.typePayment == this.newPayments.length) {
        data = this.payments.filter((element) => element.amount > 0);
      } else {
        let newData = this.payments.find(
          (element) => element.id == this.typePayment
        );

        data.push({
          id: newData.id,
          name: newData.name,
          amount: this.selectedCash,
        });
      }

      this.typePayment == null;
      this.$emit("selected-payments", data);
    },
    deleteItemConfirm() {
      this.entitys.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.selectedCash = null;
      this.typePayment = null;
      this.$emit("close-payments");
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    currencyFormat(value) {
      return new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2 }).format(value);
    },
  },
};
</script>

<style scoped>
.payment-card {
  max-height: 90vh;
  overflow-y: auto;
}
.payment-method-card {
  transition: all 0.3s;
  cursor: pointer;
  height: 100%;
}
.v-card__text {
  padding-top: 0;
}
</style>